export default __webpack_public_path__ + "static/7-confirm-order-43d054feba1ec6d46bf5dbcb0a16d636.png";